<template>
  <!-- V1 -->
  <nuxt-link
    v-if="version === 'v1'"
    :to="`/blogs/${blog.url}`"
    :external="true"
    class="n-blog-card"
  >
    <library-image
      :src="blog.image"
      :title="blog.title"
      :alt="blog.title"
      :design-width="3"
      :design-height="1.8"
    />
    <h4>{{ blog.title }}</h4>
    <p>{{ blog.description }}</p>
  </nuxt-link>

  <!-- V2 -->
  <nuxt-link
    v-else-if="version === 'v2'"
    :to="`/blogs/${blog.url}`"
    :external="true"
    class="n-blog-card n-blog-card-v2 tw-h-[520px]"
  >
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-5">
      <library-image
        :src="blog.image"
        :title="blog.title"
        :alt="blog.title"
        :design-width="3"
        :design-height="1.8"
        class="tw-rounded-lg"
      />
      <h5 class="tw-clamp-2 tw-h-[40px]">{{ blog.title }}</h5>
      <p >{{ blog.description }}</p>
    </div>
  </nuxt-link>

   <nuxt-link
    v-else-if="version === 'v3'"
    :to="`/blogs/${blog.url}`"
    :external="true"
    class="n-blog-card n-blog-card-v2 !tw-bg-[#424242] tw-h-[520px]"
  >
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-5">
      <library-image
        :src="blog.image"
        :title="blog.title"
        :alt="blog.title"
        :design-width="3"
        :design-height="1.8"
        class="tw-rounded-lg"
      />
      <h5 class="tw-clamp-2 tw-text-white tw-h-[40px]">{{ blog.title }}</h5>
      <p  class="tw-text-white">{{ blog.description }}</p>
    </div>
  </nuxt-link>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { BlogItemComponent } from '~/units/blogs/types';

export default defineNuxtComponent({
  name: 'Theme4BlogCard',

  props: {
    blog: {
      required: true,
      type: Object as PropType<BlogItemComponent>,
    },

    index: {
      required: true,
      type: Number,
    },

    version: {
      type: String as PropType<'v1' | 'v2'>,
      default: 'v1', // default olarak v1
    },
  },
});
</script>
